module.exports = __webpack_public_path__ + "static/media/metasploit-framework-logo.svg.ae7e2926.png";